import React, {PureComponent} from "react"
import {Grid} from "react-bootstrap"

import {FormattedMessage} from "@irati/utils/lang"
import ghost from "@irati/ui/images/circle_ghost.svg"

import {StyledCard, StyledH2, Picture} from "./styled"

interface OptionalProps {
  useGrid?: boolean
}
interface Props extends OptionalProps {}

const Div = (props: Props) => <div {...props} />

export default class MobileDisabled extends PureComponent<Props> {
  static defaultProps: OptionalProps = {
    useGrid: true
  }

  render() {
    const {useGrid} = this.props
    const Wrapper = useGrid ? Grid : Div
    return (
      <Wrapper>
        <StyledCard>
          <Picture src={ghost} />
          <StyledH2>
            <FormattedMessage id="platform.components.mobile.headerTwo" />
          </StyledH2>
        </StyledCard>
      </Wrapper>
    )
  }
}
